import { cookieRedirectedOnceToDM } from '../constants/app'


export const clearCookies = (url, message) => {
    return fetch(url, {
        credentials: 'include',
        method: 'GET',
        mode: 'no-cors'
    })
        .then(() => console.log(`${message} cleared.`))
        .catch(err => console.log(`Failed to clear ${message.toLowerCase()} , err: `, err))
}

export const setRedirectedCookie = () => {
    const cookieName = cookieRedirectedOnceToDM
    const cookieValue = 'true'
    const cookieStr = `${cookieName}=${cookieValue};path=/;samesite=strict;secure`
    document.cookie = cookieStr
}

export const deleteRedirectedCookie = () => {
    const cookieName = cookieRedirectedOnceToDM
    const cookieStr = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;samesite=strict;secure`
    document.cookie = cookieStr
}

export const hasRedirectedCookie = () => {
    return document.cookie
        .split('; ')
        .some(row => row.startsWith(cookieRedirectedOnceToDM + '='))
}

